import React from "react";
import BannerSlider from "../../components/banner-slider";
import ProductSlider from "../../components/product-slider";
import MainForm from "../../components/main-form";

const Homepage = () => {
  return (
    <div>
      <div className="w-full">
        <BannerSlider />
        <div className="py-14">
          <div className="container mx-auto">
            <div className="grid lg:grid-cols-3 grid-cols-1 gap-32">
              <div className="left col-span-1">
                <ProductSlider />
              </div>
              <div className="right lg:col-span-2 col-span-1">
                <MainForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
